import { render, staticRenderFns } from "./Sabores.vue?vue&type=template&id=2bf65824"
import script from "./Sabores.vue?vue&type=script&lang=js"
export * from "./Sabores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports